import React from "react"
import { withUpdateAttributionContainer } from "../../../containers/gamification2026"
import CustomButton from "../../shared/CustomButton"
import KeyDropdownValue from "../../shared/KeyDropdownValue"
import { CloseMD, CircleWarningFilled } from "../../normalizer"

const getContractNumber = (attribution) => {
  if (!attribution || !attribution.extra_fields) return ''
  const ef = attribution.extra_fields.find(
    (ef) => ef.name.toLowerCase() === 'contractnumber'
  )
  return ef ? ef.value : ''
}

const UpdateAttribution = ({
  onUserChange,
  onSubmit,
  campaign,
  users,
  selectedUser,
  onClose,
  attribution,
  preSelectedUser,
}) => {
  const contractNumber = getContractNumber(attribution)

  // Pre-select user from row dropdown when opening via "Atribuir contrato" button
  React.useEffect(() => {
    if (preSelectedUser && users && users.length > 0 && onUserChange) {
      const match = users.find(u => u.id === preSelectedUser.id)
      if (match) {
        onUserChange(match)
      }
    }
  }, [preSelectedUser, users])

  const handleSubmit = e => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <div className="update-attribution-modal">
      <div className="update-attribution-modal__header">
        <div className="update-attribution-modal__header-left">
          <h4 className="update-attribution-modal__title">Atribuir contrato</h4>
          {contractNumber && (
            <span className="update-attribution-modal__contract">{contractNumber}</span>
          )}
        </div>
        {onClose && (
          <button
            type="button"
            className="update-attribution-modal__close"
            onClick={onClose}
            aria-label="Fechar"
          >
            <CloseMD />
          </button>
        )}
      </div>
      <p className="update-attribution-modal__description">
        Selecione o nome do utilizador a atribuir o contrato.
      </p>
      <form onSubmit={handleSubmit} className="update-attribution-modal__form">
        <KeyDropdownValue
          title="Nome do utilizador"
          isClearable
          campaign={campaign}
          onChange={onUserChange}
          options={users}
          getOptionLabel={option =>
            option.employee_identifier || option.email
          }
          selectedValue={selectedUser}
          getOptionValue={option => option.id}
          placeholder="Selecione"
          name="sale-attribution-update-user-select"
        />
        <div className="update-attribution-modal__callout">
          <CircleWarningFilled className="update-attribution-modal__callout-icon" />
          <p className="update-attribution-modal__callout-text">
            Os pontos do contrato serão atribuídos ao utilizador selecionado. Este processo decorre em segundo plano. Consulte a lista de "Contratos atribuídos" dentro de instantes para confirmar.
          </p>
        </div>
        <div className="update-attribution-modal__actions">
          {onClose && (
            <CustomButton type="button" secondary onClick={onClose}>
              Cancelar
            </CustomButton>
          )}
          <CustomButton type="submit" terciary>
            Atribuir
          </CustomButton>
        </div>
      </form>
    </div>
  )
}

export default withUpdateAttributionContainer(UpdateAttribution)
